import { render, staticRenderFns } from "./import-file.vue?vue&type=template&id=4e8a3550&scoped=true"
import script from "./import-file.vue?vue&type=script&lang=js"
export * from "./import-file.vue?vue&type=script&lang=js"
import style0 from "./import-file.vue?vue&type=style&index=0&id=4e8a3550&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e8a3550",
  null
  
)

export default component.exports